import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const TitleMedium = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="240px"
        height="4px"
        viewBox="0 0 240 4"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                className="st0"
                d="M237.4,0.8c-0.3,0-0.6-0.2-0.7-0.2c-0.5,0.1-0.6,0-0.7-0.1c-0.3-0.4-1.2-0.1-1.8-0.2c-0.7,0.5-1.5,0-2.2,0
		c-0.5,0.1-1.1,0.2-1.4,0.1c-1.1-0.2-2.3-0.2-3.4-0.1c-0.7,0-1.1,0-1.6-0.3c-0.2,0.3-0.3,0.5-0.5,0.7c-1.3-0.6-2.8-0.6-4.3-0.3
		c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3,0.1-0.6,0.2-0.8,0.2c-0.2,0.1-0.5,0.1-1,0.2c-0.2-0.1-0.3-0.3-0.3-0.3c-0.9,0.1-1.8,0.2-2.3,0.2
		c-1.2-0.2-2.4-0.1-3.6,0c-1.2,0.1-2.6,0.3-3.4-0.2c-0.6,0.1-1,0.1-1.4,0.1c-0.5,0-0.9-0.1-1.4-0.2c-0.3,0.3-0.8,0.4-1.5,0.3
		c-0.5-0.1-1-0.2-1.5-0.2c-0.7-0.1-1.5-0.1-1.8,0.3c-0.6-0.2-1.2-0.3-1.7-0.4c-0.4,0.2-0.7,0.3-1.1,0.5c-0.2-0.2-0.3-0.3-0.4-0.4
		c-0.7,0-1.4,0-1.3,0.3c-0.5,0-1,0-1.4,0c-0.3,0-0.7,0.1-1,0c-0.9-0.1-1.7-0.4-2.5,0c-0.1,0-0.3,0-0.3,0c-0.6-0.2-1.3,0-2-0.1
		c-0.3,0-0.6-0.1-0.9-0.2c-1.1,0.2-1.1,0.2-3.3,0c0,0.1-0.1,0.2-0.1,0.4c-1.7-0.2-3.3-0.4-4.9-0.1c-1.2-0.2-2.7,0.3-3.5-0.2
		c-0.6,0.1-1.1,0.2-1.6,0.2c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3,0.2-0.4,0.3-0.5,0.3c-0.9,0-1.7-0.1-2.4-0.1c-0.8,0-1.5,0.1-2.2-0.1
		c-0.2-0.1-0.5-0.1-0.8-0.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.8-0.1-1.6-0.2-2.3-0.3c-0.1,0-0.2,0-0.3,0c-0.4,0.1-0.8,0.3-1.2,0.4
		c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6,0.1-1,0.2-1.4,0.1c-0.4,0-0.6-0.2-0.8-0.3c-0.6,0.1-1.2,0.3-1.6,0.2c-2.1-0.1-4.2,0-6.2-0.2
		c-0.3,0-0.7-0.1-0.8,0c-1.3,0.4-2.7-0.1-4.1,0.1c-1-0.5-1.6-0.1-2.2,0.2c-0.8-0.4-1.6-0.5-2.6-0.2c-0.2,0-0.5,0.1-0.7,0
		c-1.1-0.2-1.9,0.1-2.6,0.4c-0.2-0.2-0.4-0.3-0.5-0.3c-1.2,0.1-2.4-0.1-3.6,0c-1.5,0-3.1,0.3-4.6,0.1c-1,0.2-1.8,0-2.7-0.1
		c-0.3,0-0.9-0.1-0.9,0c-0.8,0.5-1.5,0.1-2.2,0c-1.4,0.3-1.6,0.3-1.7-0.3c-0.4,0.2-0.7,0.4-1.1,0.6c-0.9-0.4-2.3,0.1-3.3-0.4
		c-0.2,0.2-0.4,0.4-0.6,0.5c-0.7-0.2-1.4-0.4-2-0.6c-1.1,0.4-2.4,0-3.6,0.1c0,0.1,0,0.2,0,0.3c-1.1,0.1-2,0-2.6-0.4
		c-0.7,0.1-1.1,0.5-2,0.3c-1.2-0.3-1.3,0.1-1.8,0.3c-0.6-0.2-1-0.7-2-0.2c-0.3-0.2-0.6-0.3-0.8-0.5c-0.7,0.1-1.1,0.2-1.5,0.3
		c-0.2-0.1-0.3-0.2-0.4-0.3c-0.6,0.1-1.2,0.2-1.8,0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.4,0.2-0.7,0.3-1.2,0.5c-0.2-0.2-0.4-0.3-0.6-0.5
		c-1.1,0.4-2.2,0.4-3.2,0.3c-1.5-0.2-2.7-0.1-4,0c-0.7,0-1.3,0-1.8-0.1c-0.8-0.1-0.9,0.3-1.6,0.2c-0.3-0.1-0.6-0.3-0.9-0.4
		c-0.6,0.2-1.1,0.3-1.5,0.5c-0.7-0.1-1.4-0.3-2.1-0.4c-0.3,0.1-0.5,0.2-0.7,0.3c-0.3,0-0.7,0-1-0.1c-0.4,0-0.8,0-1.2,0
		c-0.8-0.1-1.7-0.3-2.3,0.1c-0.9-0.2-2.1,0.1-3-0.3c-0.4-0.1-0.8-0.1-1,0.1c-0.2,0.2-0.5,0.2-0.9,0.2c-0.3,0-0.5,0.1-0.7,0.2
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.4-0.2c-0.3,0.1-0.6,0.1-0.9,0.1c-0.6,0-1.2-0.1-1.9-0.2c-1.1-0.1-1.5,0.1-1.9,0.5
		c0,0-0.3,0-0.5,0.1c0-0.2,0.1-0.4,0.1-0.7c-0.6,0.1-0.9,0.1-1.3,0.1c-0.3,0-0.7,0.1-0.9,0c-0.3-0.1-0.3-0.2-0.6-0.5
		c-0.6,0.2-1.1,0.3-1.6,0.5c-0.5,0-1.1-0.1-1.7-0.1c-1.4-0.2-1.4-0.2-2.2,0.2c-0.5-0.3-1.4-0.4-2.1-0.3c-0.7,0.1-1.2,0.1-1.8,0
		c-0.8,0-1.6-0.1-2.4,0.1c-0.5,0.1-1,0-1.4-0.1c-0.8-0.1-1.2-0.1-1.3,0.2c-1.6,0.2-2.8-0.3-4.4-0.4c0.2,0.2,0.2,0.3,0.3,0.4
		c-1.2,0.1-1.8-0.1-2.2-0.5c-0.7,0.2-1,0.2-2.1,0.2c-0.1,0-0.4,0-0.4,0c-0.6,0.3-1.2,0.2-1.8,0c-0.3-0.1-1.1,0-1.1,0
		c-0.2,0.3-1,0.1-1.2,0.2c-0.7,0.3-1.1-0.1-1.7-0.1c-0.6,0.1-1.2,0.2-2,0c-0.4-0.1-1.4,0-2.1,0c-0.9,0.1-1.6-0.1-2.4-0.3
		c-0.2,0.1-0.4,0.2-0.6,0.4c-0.6-0.2-1-0.3-1.5-0.4c-0.6,0.5-1.5,0.4-2.5,0.3c-0.4-0.1-0.9-0.1-1.4-0.2c0.2,0.2,0.3,0.3,0.4,0.5
		c-0.8-0.1-1.6,0-1.8-0.2c-0.8-0.4-1.3-0.3-2.2,0c-0.8,0.2-1.9,0.2-2.9,0.2c-0.5,0-0.9-0.2-1.4-0.4c-0.8,0.3-1.5,0.4-2.2,0.4
		c-1-0.1-3-0.2-4-0.1c-0.7,0.1-1.3,0-1.5-0.3c0,0-0.2-0.1-0.4-0.1c0,0.1,0,0.2,0,0.4C4.6,0.5,3.4,0.4,2.6,0.4
		C1.9,0.6,1.5,0.7,1.2,0.8C0.7,1,0.1,1.2,0,1.4l1.4,0.3c0.9,0,2.1,0.1,3.5,0.2c0-0.1,0-0.2,0-0.4c0.2,0.1,0.4,0.1,0.5,0.1
		C5.6,2,6.1,2,6.9,1.9c0.4,0,1-0.1,1.7-0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0C9.6,1.9,10.4,2,11,2c0.7,0.1,1.4,0,2.2-0.4
		c0.5,0.1,0.9,0.4,1.4,0.4c1,0,2.2,0,3-0.2c1-0.2,1.5-0.4,2.3,0C20.2,2.1,21,2,21.8,2.1c-0.2-0.2-0.3-0.3-0.4-0.5
		c0.6,0.1,1.1,0.1,1.5,0.2c1,0.2,2,0.3,2.6-0.3c0.1,0,0.2,0,0.2,0.1c0,0,0,0,0,0c0,0,0.2-0.1,0.4-0.2c0.1,0.1,0.1,0.2,0.1,0.3
		c0,0,0,0-0.1,0c0.3,0.1,0.6,0.2,0.9,0.3c0.2-0.1,0.4-0.2,0.6-0.4c0.8,0.2,1.5,0.4,2.4,0.3c0.7-0.1,1.8-0.2,2.2,0
		c0.8,0.3,1.4,0.1,2,0c0.7-0.1,1,0.4,1.8,0.1c0.1-0.1,1,0.1,1.2-0.2c0,0,0.2,0,0.3,0c-0.1-0.1-0.2-0.1-0.2-0.1c0,0,0.2-0.1,0.3-0.1
		c0.1,0,0.3,0.1,0.3,0.1c0,0-0.1,0.1-0.2,0.1c0.2,0,0.5,0,0.7,0c0.7,0.2,1.2,0.3,1.9,0c0.1,0,0.3,0,0.4,0c1.1,0,1.4,0,2.1-0.2
		c0.4,0.4,1,0.6,2.3,0.5c-0.1-0.1-0.2-0.2-0.4-0.4c1.6,0.1,2.9,0.6,4.6,0.4c0.2-0.3,0.6-0.4,1.4-0.2c0.5,0.1,0.9,0.2,1.5,0.1
		c0.8-0.2,1.6-0.1,2.5-0.1c0.6,0,1.2,0.1,1.9,0c0.7-0.1,1.7-0.1,2.2,0.3c0.8-0.5,0.8-0.4,2.3-0.2C61.8,1.9,62.5,1.9,63,2
		c0.6-0.2,1.1-0.3,1.7-0.5c0.3,0.2,0.3,0.4,0.6,0.5c0.2,0.1,0.6,0,0.9-0.1c0.4,0,0.8-0.1,1.4-0.1c0,0.3-0.1,0.5-0.1,0.7
		c0.2,0,0.5,0,0.5-0.1c0.4-0.5,0.9-0.6,2-0.5c0.6,0,1.3,0.1,1.9,0.2c0.3,0,0.5-0.1,0.9-0.1c0.1,0,0.2,0.1,0.4,0.2
		c0.2,0.1,0.4,0.1,0.6,0.2C74.1,2.1,74.3,2,74.6,2c0.4,0,0.8,0,1-0.2c0.2-0.2,0.6-0.2,1-0.1c0.9,0.3,2.1,0,3.1,0.3
		c0.6-0.5,1.5-0.2,2.3-0.1c0.4,0,0.8,0,1.3,0c0.3,0,0.7,0,1.1,0.1c0.2-0.1,0.4-0.2,0.7-0.4c0.7,0.1,1.4,0.3,2.2,0.4
		c0.5-0.2,1-0.3,1.6-0.5c0.3,0.1,0.6,0.3,0.9,0.4c0.7,0.1,0.9-0.3,1.7-0.2c0.5,0.1,1.1,0.1,1.8,0.1c1.3-0.2,2.6-0.3,4.1,0
		c1,0.2,2.1,0.1,3.3-0.3c0.2,0.2,0.4,0.3,0.6,0.5c0.5-0.2,0.8-0.4,1.2-0.5c0.3,0.1,0.5,0.3,0.7,0.4c0.6-0.1,1.2-0.2,1.9-0.4
		c0.1,0.1,0.3,0.1,0.5,0.3c0.4-0.1,0.9-0.2,1.5-0.3c0.3,0.1,0.5,0.3,0.9,0.5c0,0,0,0,0,0c-0.2-0.2-0.1-0.4,0.1-0.6
		c0.1,0.1,0.3,0.3,0.4,0.4c0.7-0.2,1.1,0.2,1.6,0.4c0.5-0.2,0.6-0.7,1.8-0.3c0.9,0.2,1.3-0.2,2-0.3c0.6,0.4,1.5,0.5,2.7,0.4
		c0-0.1,0-0.2,0-0.3c1.2-0.1,2.6,0.3,3.7-0.1c0.7,0.2,1.4,0.4,2.1,0.6c0.2-0.2,0.4-0.4,0.7-0.6c1,0.5,2.5-0.1,3.4,0.4
		c0.4-0.2,0.7-0.4,1.1-0.7c0.1,0.6,0.3,0.6,1.8,0.3c0.7,0.1,1.4,0.6,2.3,0c0.1,0,0.7,0,1,0c0.7,0.1,1.4,0.3,2.1,0.2
		c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c1.6,0.2,3.2-0.1,4.8-0.1c1.2,0,2.5,0.2,3.8,0c0.1,0,0.3,0.2,0.5,0.3
		c0.7-0.3,1.5-0.5,2.7-0.4c0.2,0,0.5,0,0.7,0c1.1-0.3,1.9-0.2,2.7,0.2c0.7-0.3,1.3-0.7,2.3-0.2c1.4-0.2,2.9,0.4,4.2-0.1
		c0.2-0.1,0.6,0,0.9,0c2.1,0.2,4.3,0.1,6.4,0.2c0.5,0,1.1-0.2,1.7-0.3c0.2,0.1,0.5,0.2,0.9,0.3c0.4,0,0.9-0.1,1.5-0.1
		c0.2,0.1,0.4,0.2,0.5,0.3c0.4-0.1,0.9-0.3,1.3-0.4c0.1,0,0.2,0,0.3,0c0.8,0.1,1.5,0.2,2.4,0.3c0.1-0.2,0.2-0.3,0.2-0.5
		c0.3,0,0.6,0.1,0.8,0.1c0.7,0.2,1.5,0.2,2.3,0.1c0.7,0,1.5,0.1,2.5,0.1c0,0,0.2-0.2,0.5-0.3c0.4,0.2,0.6,0.3,0.9,0.4
		c0.2,0,0.4-0.1,0.7-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.4,0,0.6,0,0.8,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.1,0.1,0.2,0.1
		c-0.2-0.2,0.1-0.4,0.7-0.5c0.1,0.2,0.1,0.3,0.2,0.5c-0.3,0-0.6,0-0.8,0c0.9,0.3,2.3-0.1,3.5,0.1c1.7-0.3,3.4-0.1,5.1,0.1
		c0-0.1,0.1-0.3,0.1-0.4c2.4,0.2,2.4,0.2,3.5,0c0.3,0.1,0.6,0.2,0.9,0.2c0.7,0,1.4-0.1,2,0.1c0.1,0,0.3,0,0.3,0
		c0.9-0.3,1.7-0.1,2.6,0c0.3,0,0.7,0,1,0c0.5,0,0.9,0,1.5,0c-0.1-0.4,0.6-0.4,1.3-0.3c0.1,0.1,0.2,0.3,0.4,0.5
		c0.4-0.2,0.7-0.3,1.1-0.5c0.6,0.1,1.1,0.3,1.8,0.4c0.3-0.4,1.1-0.4,1.8-0.3c0.5,0,1,0.1,1.5,0.2c0.8,0.1,1.3,0,1.6-0.3
		c0.5,0.1,0.9,0.2,1.4,0.2c0.4,0,0.9-0.1,1.5-0.1c0.8,0.5,2.2,0.3,3.5,0.2c1.2-0.1,2.4-0.2,3.7,0c0.6,0.1,1.5-0.1,2.4-0.2
		c0,0,0.2,0.1,0.3,0.3c0.5-0.1,0.8-0.2,1-0.2c0.3-0.1,0.5-0.1,0.8-0.2c0.3,0.1,0.5,0.2,0.9,0.3c1.6-0.3,3.1-0.3,4.5,0.3
		c0.2-0.3,0.3-0.5,0.5-0.8c0.5,0.3,0.9,0.4,1.6,0.3c1.1-0.1,2.3-0.1,3.5,0.1c0.3,0.1,1-0.1,1.4-0.2c0.3,0,0.6,0.1,0.9,0.1
		c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.3-0.6-1.2-0.7c-0.3,0-0.5-0.2-0.8-0.2C237.8,0.7,237.5,0.8,237.4,0.8z M9.6,1.5
		c-0.8,0.1-1.1,0-0.9-0.4C9.1,1.3,9.3,1.4,9.6,1.5z M13.9,1c-0.1,0-0.3-0.1-0.4-0.1c0.1,0,0.2-0.1,0.3-0.2c0.2,0.1,0.3,0.1,0.4,0.1
		C14.2,0.9,14.1,1,13.9,1z M19.7,1.5c0,0-0.2,0-0.3,0c0-0.1-0.1-0.2-0.1-0.3c0.1,0,0.3,0,0.4,0C19.7,1.3,19.7,1.4,19.7,1.5z
		 M23.9,1.3C23.6,1,23.6,1,24.6,1C24.3,1.1,24.1,1.2,23.9,1.3z M40.1,1.8c0,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.1-0.2-0.2
		c0,0,0.2-0.1,0.3-0.2C40.1,1.7,40.2,1.7,40.1,1.8z M42.3,0.9c-0.2,0-0.3-0.1-0.4-0.1c0.1,0,0.2-0.1,0.4-0.1
		c0.1,0.1,0.3,0.1,0.4,0.2C42.5,0.9,42.4,0.9,42.3,0.9z M49.9,1.5c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.3-0.1-0.3-0.1
		c0,0,0.1-0.1,0.2-0.1C49.6,1.4,49.7,1.5,49.9,1.5z M107.8,1.4c-0.7,0.1-0.8,0-0.7-0.4C107.5,1.2,107.7,1.3,107.8,1.4z M137.7,1.2
		c0.3-0.2,0.5-0.4,1.3-0.3C138.7,1.1,138.6,1.3,137.7,1.2z"
            />
            <path
                fill={color}
                className="st0"
                d="M110.5,2.8c-0.2-0.1-0.3-0.2-0.7-0.4C109.6,2.8,109.8,2.9,110.5,2.8z"
            />
            <path
                fill={color}
                className="st0"
                d="M141.4,2.5c0.9,0.2,1.1-0.1,1.4-0.3C142,2.1,141.7,2.3,141.4,2.5z"
            />
            <path
                fill={color}
                className="st0"
                d="M25.5,3.1c0.1,0,0.4,0,0.4-0.1c0-0.1,0-0.2-0.1-0.3c-0.2,0.1-0.4,0.1-0.4,0.2C25.4,3,25.5,3,25.5,3.1z"
            />
            <path
                fill={color}
                className="st0"
                d="M23.5,2.7c0.3-0.1,0.5-0.2,0.7-0.3C23.2,2.4,23.2,2.4,23.5,2.7z"
            />
            <path
                fill={color}
                className="st0"
                d="M18.9,2.9c0.1,0,0.3,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.3,0-0.4,0C18.8,2.7,18.8,2.8,18.9,2.9z"
            />
            <path
                fill={color}
                className="st0"
                d="M12.8,2.2c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2-0.1,0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1C13,2.1,12.9,2.2,12.8,2.2z"
            />
            <path
                fill={color}
                className="st0"
                d="M42.1,2.2c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.3-0.1,0.4-0.1c-0.1-0.1-0.2-0.1-0.4-0.2C42.3,2.1,42.2,2.1,42.1,2.2z
		"
            />
            <path
                fill={color}
                className="st0"
                d="M49.8,2.9c0,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.2,0-0.3-0.1-0.4-0.1C49.9,2.8,49.8,2.9,49.8,2.9z"
            />
            <path
                fill={color}
                className="st0"
                d="M58.3,3.9c0,0,0.2,0.1,0.3,0.1C58.8,4,59,3.9,59,3.9c0-0.1-0.1-0.1-0.3-0.3C58.4,3.8,58.3,3.8,58.3,3.9z"
            />
            <path
                fill={color}
                className="st0"
                d="M40,3.3c0.1,0,0.3-0.1,0.3-0.1c0-0.1-0.1-0.1-0.2-0.2C40,3,39.8,3.1,39.8,3.1C39.8,3.2,39.9,3.2,40,3.3z"
            />
            <path
                fill={color}
                className="st0"
                d="M38.1,2.9c0-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.3,0.1-0.3,0.1c0,0.1,0.1,0.1,0.3,0.2C38,3,38.1,3,38.1,2.9z"
            />
            <path
                fill={color}
                className="st0"
                d="M42,4c0.1,0,0.2-0.1,0.3-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C41.8,3.9,41.9,4,42,4z"
            />
        </g>
    </svg>
);

TitleMedium.propTypes = propTypes;
TitleMedium.defaultProps = defaultProps;

export default TitleMedium;
